import {
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  RESET_EVENTS_STATE,
} from "../../../types/event";

const initialState = {
  loading: false,
  // data: [],
  error: "",
  success: false,
};

const fetchEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        success: false,
      };
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload || [],
        success: true,
      };
    case FETCH_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || "Failed to fetch events",
        success: false,
      };
    case RESET_EVENTS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default fetchEventsReducer;
